import { fetch, createModel } from "app-common";

export const addLead = ({ number, name, email, phone }) => {
	return fetch.post("public/balance/add/lead", {
		number,
		name,
		email,
		phone
	});
};

export const search = ({ name }) => {
	return fetch.get("public/balance/search/count", {
		name
	});
};
